import { Box } from "@mui/material";
import CustomTableRow from "../table/CustomTableRow";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../AppContextDef";
import { DeleteOutlined, EditOutlined } from "@mui/icons-material";
import { replaceMappingIdsWithVariables } from "../../utils/common";
import React, { useEffect, useState } from "react";
import useAuthFetch from "../../hooks/useAuthFetch";
import ConfirmBox from "../ConfirmBox";
import toast from "react-hot-toast";
import Cookies from "js-cookie"

export default function JourneyConfigTableRow({ row, refetch }) {
  const customFetch = useAuthFetch();
  const navigate = useNavigate();
  const [variables, setVariables] = React.useState([]);
  const [errMsg, setErrMsg] = useState(null);
  const search = "?" + window.location.hash.split("?")[1];
  const params = new URLSearchParams(search);
  const [openErr, setOpenErr] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  let page = params.get("page") || 1;

  const { setJourneyConfigRowData } = useAppContext();

  const fetchVariables = async () => {
    const url = new URL(
      `${process.env.REACT_APP_API_URL}/v1/dashboard/variableMappings/fetchAll?productType=${row.productType}`
    );
    const method = "GET"
    const { response, status } = await customFetch(
      url,
      method,
    );

    if (status === 200) {
      setVariables(response);
    } else {
      console.log("Error fetching variables");
    }
  };

  const handleUpdate = () => {
    setJourneyConfigRowData(row);
    navigate(`${row.configId}`);
  };

  const handleDelete = async () => {
    try {
      const url = new URL(`${process.env.REACT_APP_API_URL}/v1/dashboard/journeyConfig/delete`);
      const method = "POST"
      const bodyContent = { id: row.configId }

      const { response, status, message } = await customFetch(
        url,
        method,
        bodyContent
      );

      if (status !== 200) {
        setOpenConfirm(false);
        setOpenErr(true);
        setErrMsg(message);
        console.log("Error in deleting journey config", response);
      }
      toast.success("Template Deleted Succesfully!", {
        position: "bottom-right",
      });
      setOpenConfirm(false);
      refetch();
    } catch (error) {
      console.error("Error delete configuration:", error);
    }
  };
  const ShowButtons = () => {

    return (
      JSON.parse(Cookies.get("userDets")).role === "ADMIN" ? <Box
        sx={{
          display: "flex",
          gap: 1,
        }}
      >
        <button onClick={handleUpdate}>
          <EditOutlined className="w-5 h-5 text-black-150" />
        </button>
        <button onClick={() => setOpenConfirm(true)}>
          <DeleteOutlined className="w-5- h-5 text-black-150" />
        </button>
      </Box>
        : "-"
    );
  };

  React.useEffect(() => {
    async function fetchData() {
      await fetchVariables();
    }

    fetchData();
  }, [page]);

  let voiceoverPolicyDetails = replaceMappingIdsWithVariables({
    text: row.voiceoverPolicyDetails || "",
    variables: variables,
  });
  let voiceoverPersonalDetails = replaceMappingIdsWithVariables({
    text: row.voiceoverPersonalDetails || "",
    variables: variables,
  });
  let clientScript = replaceMappingIdsWithVariables({
    text: row.clientScript || "",
    variables: variables,
  });
  let policyConfirmationText = replaceMappingIdsWithVariables({
    text: row.policyConfirmationText || "",
    variables: variables,
  });

  // const language = row?.supportedLanguages?.map((lang) => lang) || [];

  return (
    <>
      <CustomTableRow
        columns={[
          {
            text: row.configId,
          },
          {
            text: row.templateName,
          },
          {
            text: row.productType,
          },
          {
            text: row.productCodeType && row.productCodeValue 
              ? (row.productCodeType === "EXACT" 
                ? row.productCodeValue 
                : `Starting With: ${row.productCodeValue}`)
              : "-",
          },
          {
            text: policyConfirmationText,
          },
          {
            text: row.language,
          },
          {
            text: voiceoverPersonalDetails,
          },
          {
            text: voiceoverPolicyDetails,
          },
          {
            text: clientScript,
          },
          {
            text: `${row.allowedTimeForScript}`,
          },
          {
            text: `${row.textMatchPercentage}`,
          },
          {
            actions: [ShowButtons],
          },
        ]}
      ></CustomTableRow>
      <ConfirmBox
        open={openErr}
        setOpen={setOpenErr}
        buttonText={"Close"}
        text={
          errMsg ? errMsg : "Something went wrong while deleting the template!"
        }
      />
      <ConfirmBox
        open={openConfirm}
        setOpen={setOpenConfirm}
        buttonText={"Confirm"}
        buttonHandler={() => {
          handleDelete();
        }}
        extraButtonText={"Cancel"}
        extraButtonHandler={() => {
          setOpenConfirm(false);
        }}
        text={"Are you sure you want to delete the template?"}
      />
    </>
  );
}
